import React from 'react';
import styled from 'styled-components';
import Notification from '../../../classes/Notification/Notification';
import BlueDotIcon from '../../../icons/BlueDotIcon';
import TickCircle from '../../../icons/TickCircle';
import ReactTooltip from '../../tooltip/ReactTooltip';

const IconContainer = styled.div``;

interface Props{
  notification: Notification,
}

function MarkReadUnreadStatusIcon({ notification }: Props) {
  return (
    <ReactTooltip
      place="left"
      tip={notification.read.isRead ? 'Mark as unread' : 'Mark as read'}
    >
      <IconContainer className="unreadIcon">
        <BlueDotIcon />
      </IconContainer>
      <IconContainer className="readIcon">
        <TickCircle />
      </IconContainer>
    </ReactTooltip>
  );
}

export default MarkReadUnreadStatusIcon;
